// contains code for Efficient Trim and Optimal Trim
import React from "react";
import BehaviourBarGraph from "../BehaviourBarGraph.jsx";
import { formatNumber } from "@signolteam/shared/units-of-measure";

export default function graph({
  originLabel,
  axisLabel,
  trim,
  perfectTrimM,
  lowerLimitMeters,
  upperLimitMeters,
  bvrColour,
  isExample = false,
}) {
  const additionalThresholds = [
    lowerLimitMeters - perfectTrimM,
    upperLimitMeters - perfectTrimM,
  ];
  const additionalThresholdsActualValues = [
    `Threshold${
      isExample
        ? ""
        : ` (${
            formatNumber(lowerLimitMeters, {
              unit: "m",
              precision: 2,
            }).formattedValue
          })`
    }`,
    `Threshold${
      isExample
        ? ""
        : ` (${
            formatNumber(upperLimitMeters, {
              unit: "m",
              precision: 2,
            }).formattedValue
          })`
    }`,
  ];

  // Calculate the amount of deviation from the trim
  const trimUnderPerfect = trim <= perfectTrimM;
  const diff = trim - perfectTrimM;

  // Calculate if the deviation is within the additionalThresholds
  const trimWithinThreshold = trimUnderPerfect
    ? diff >= additionalThresholds[0]
    : diff <= additionalThresholds[1];
  const thresholdUsed = trimUnderPerfect
    ? additionalThresholds[0]
    : additionalThresholds[1];

  let firstBarValue = 0;
  let secondBarValue = 0;
  if (trimWithinThreshold) {
    firstBarValue = diff;
    secondBarValue = 0;
  } else {
    firstBarValue = thresholdUsed;
    secondBarValue = diff - thresholdUsed;
  }

  const firstBarColour = trimWithinThreshold
    ? bvrColour.codes["500"]
    : bvrColour.codes["200"];
  const data = [
    {
      beforeThreshold: firstBarValue,
      afterThreshold: secondBarValue,
      underThresholdColour: firstBarColour,
      overThresholdColour: bvrColour.codes["900"],
    },
  ];

  const domainMax =
    diff > additionalThresholds[1] ? diff + 0.5 : additionalThresholds[1] + 0.5;
  const domainMin =
    diff < additionalThresholds[0] ? diff - 0.5 : additionalThresholds[0] - 0.5;

  const domain = [domainMin, domainMax];

  const formattedTrim = formatNumber(trim, {
    unit: "m",
    precision: 2,
    options: {
      boundaryValues: additionalThresholds,
    },
  }).formattedValue;

  const thresholdLineColour = bvrColour.codes["900"];
  return (
    <BehaviourBarGraph
      data={data}
      moveOrigin={true}
      hideYAxisOnDesktop={true}
      hideXLineOnMobile={true}
      additionalThresholdsRelative={additionalThresholds}
      additionalThresholdsActualValues={additionalThresholdsActualValues}
      originLabel={originLabel}
      mobileDomain={domain}
      domain={domain}
      refLineColour={thresholdLineColour}
      success={trimWithinThreshold}
      unitOfMeasure={` m`}
      axisLabel={axisLabel}
      hideYLine={true}
      hideNum={true}
      showTicks={false}
      hideTopLabel={true}
      barLabelFormatter={() =>
        `Actual trim${isExample ? "" : ` (${formattedTrim})`}`
      }
      barLabelFormatterMobile={() =>
        `${isExample ? "Actual trim" : formattedTrim}`
      }
      invertBarLabels={trimUnderPerfect}
      isExample={isExample}
    />
  );
}
